import type { BasicProductData } from 'components/layout/modals/compatible-combinations-browser-modal';

export const basicProductTitle = (
  product: BasicProductData | null | undefined,
  fallback: string
): string =>
  product?.shortDescription ??
  product?.description ??
  product?.name ??
  fallback;
